module.exports = __webpack_public_path__ + "static/media/filter.998937ea.svg";